import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";

import { updateNavigation } from "../../store/mainReducer";
import { ROUTES } from "../../routing/routes";
import { BiMenu } from "react-icons/bi";
import { Menu, MenuItem } from "@mui/material";
import { COLORS } from "../../utils/colors";

export const SmallMenu = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const menuNavigation = useSelector((state) => state.main.ui?.menuNavigation);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const goToHome = () => {
    dispatch(updateNavigation("home"));
    handleClose();
    navigate(ROUTES.DEFAULT);
  };

  const goToAccount = () => {
    dispatch(updateNavigation("account"));
    handleClose();
    navigate(ROUTES.ACCOUNT);
  };

  const goToEvents = () => {
    dispatch(updateNavigation("events"));
    handleClose();
    navigate(ROUTES.EVENTS);
  };

  const goToAbout = () => {
    dispatch(updateNavigation("about"));
    handleClose();
    navigate(ROUTES.ABOUT);
  };

  const goToExtensions = () => {
    dispatch(updateNavigation("extensions"));
    navigate(ROUTES.EXTENSIONS);
  };

  return (
    <div className="small-menu-wrapper">
      <BiMenu size={"2em"} onClick={handleClick} />
      <Menu
        id="burger-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        // MenuListProps={{
        //   "aria-labelledby": "basic-button",
        // }}
      >
        <MenuItem
          onClick={goToHome}
          style={{
            color:
              menuNavigation === "home" ? COLORS.darkNeon : COLORS.menuText,
          }}
        >
          Home
        </MenuItem>
        <MenuItem
          onClick={goToAccount}
          style={{
            color:
              menuNavigation === "account" ? COLORS.darkNeon : COLORS.menuText,
          }}
        >
          My Account
        </MenuItem>
        <Tooltip
          title={"Coming soon"}
          disableFocusListener
          style={{ padding: "0px" }}
        >
          <IconButton>
            <MenuItem
              style={{
                color: COLORS.lightGrey,
              }}
              disabled={true}
            >
              Create Event
            </MenuItem>
          </IconButton>
        </Tooltip>
        <MenuItem
          onClick={goToExtensions}
          style={{
            color:
              menuNavigation === "extensions"
                ? COLORS.darkNeon
                : COLORS.menuText,
          }}
        >
          Extensions
        </MenuItem>
        {/* {userData?.user ? (
          <MenuItem onClick={displayAccountModal}>My Account</MenuItem>
        ) : (
          <MenuItem onClick={displayLoginModal}>Login</MenuItem>
        )} */}
      </Menu>
    </div>
  );
};
